<template>
  <form-section v-loading="loading">
    <div ref="map">
      <div class="graph"></div>
    </div>
  </form-section>
</template>
<script>
import FormSection from '@/common/components/form/FormSection'
import SingleLocationChart from '@/jquery/analytics/charts/singleLocationChart'

export default {
  name: 'ProfileLocationsMap',

  components: {
    FormSection
  },

  props: {
    projectId: {
      type: [String, Number],
      required: true
    },

    title: {
      type: String,
      required: false
    },

    loading: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      chart: null
    }
  },

  mounted() {
    this.initializeMap()
  },

  beforeDestroy() {
    this.chart.destroy()
  },

  computed: {
    mapStyles() {
      return [
        {
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5'
            }
          ]
        },
        {
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161'
            }
          ]
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            {
              color: '#f5f5f5'
            }
          ]
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#bdbdbd'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee'
            }
          ]
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575'
            }
          ]
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5'
            }
          ]
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e'
            }
          ]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff'
            }
          ]
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [
            {
              color: '#dadada'
            }
          ]
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161'
            }
          ]
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e'
            }
          ]
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5'
            }
          ]
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee'
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#c9c9c9'
            }
          ]
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e'
            }
          ]
        }
      ]
    }
  },

  methods: {
    initializeMap() {
      var that = this
      this.chart = new SingleLocationChart({
        method: 'locations_map',
        element: $(this.$refs.map),
        styles: this.mapStyles,
        title: this.title,
        chartSettings: {
          setAddress: function(locationId, address, countryName) {
            that.$emit('update-address', locationId, address, countryName)
          },
          mapReady: function() {
            that.$emit('map-ready')
          }
        }
      })

      this.chart.reloadByParam(
        {},
        {
          project_id: this.projectId
        }
      )
    },

    refreshMap(latitude, longitude, radius) {
      this.chart.refreshMap(latitude, longitude, radius)
    },

    setAddress(geometry) {
      this.chart.setNewAddress(geometry.location)
    }
  }
}
</script>
<style scoped>
>>> .el-card__body {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/modules/data-manager/components/DataManagerLocationsMap.vue